import React from 'react';

import { Box, Typography } from '@mui/material';
import DrawerCDS, { DrawerSize } from '@sharedCR/coreDesignSystem/Drawer/DrawerCDS';
import EntityAuditHistory from 'app/shared/modules/EntityAuditHistory';
import {
  DEFAULT_HISTORY_TITLE,
  EMPTY_FIELD_LIST,
} from 'app/shared/modules/EntityAuditHistory/EntityAuditHistory.constants';
import {
  AuditClientPropType,
  AuditExtensionPropTypes,
} from 'app/shared/modules/EntityAuditHistory/EntityAuditHistory.propTypes';
import PropTypes from 'prop-types';

import { contentStyles, subtitleStyles } from './EntityAuditHistoryDrawer.styles';

/**
 * `size` takes a named drawer width (`DrawerSize.*` or a `constants/ui` width constant), never a
 * literal px. The remaining optional props are EntityAuditHistory's extension points, passed through.
 */
const EntityAuditHistoryDrawer = ({
  entityType,
  entityId = null,
  title = DEFAULT_HISTORY_TITLE,
  dataTestId = null,
  size = DrawerSize.LARGE,
  auditClient,
  renderers = null,
  hiddenFields = EMPTY_FIELD_LIST,
  snapshotExcludedFields = EMPTY_FIELD_LIST,
  getRowDecoration = null,
  shadowedToggle = null,
  renderRowActions = null,
  renderDetailExtras = null,
  changePanels = null,
  isSnapshotHidden = false,
  automaticFields = EMPTY_FIELD_LIST,
  open,
  onClose,
}) => (
  <DrawerCDS
    content={
      // DrawerCDS requires a non-null `content`; render the timeline only while open (and with a
      // real id) so EntityAuditHistory still fetches on open, but always hand the drawer a valid node.
      <Box sx={contentStyles}>
        {open && entityId && (
          <>
            {title !== DEFAULT_HISTORY_TITLE && (
              <Typography color="text.secondary" sx={subtitleStyles} variant="regular14">
                {DEFAULT_HISTORY_TITLE}
              </Typography>
            )}
            <EntityAuditHistory
              auditClient={auditClient}
              automaticFields={automaticFields}
              changePanels={changePanels}
              collapsible={false}
              entityId={entityId}
              entityType={entityType}
              getRowDecoration={getRowDecoration}
              hiddenFields={hiddenFields}
              isSnapshotHidden={isSnapshotHidden}
              renderDetailExtras={renderDetailExtras}
              renderRowActions={renderRowActions}
              renderers={renderers}
              shadowedToggle={shadowedToggle}
              snapshotExcludedFields={snapshotExcludedFields}
            />
          </>
        )}
      </Box>
    }
    dataTestId={dataTestId}
    open={open}
    size={size}
    title={title}
    onClose={onClose}
  />
);

EntityAuditHistoryDrawer.propTypes = {
  entityType: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  entityId: PropTypes.string,
  title: PropTypes.string,
  dataTestId: PropTypes.string,
  size: PropTypes.string,
  auditClient: AuditClientPropType,
  ...AuditExtensionPropTypes,
};

export default EntityAuditHistoryDrawer;
